import { alpha, Chip, styled } from '@mui/material';

export const ToolChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'locked',
})<{ locked?: boolean }>(({ theme, locked }) => {
  const tint = locked ? theme.palette.text.secondary : theme.palette.primary.main;
  return {
    fontWeight: 600,
    color: locked ? theme.palette.text.secondary : theme.palette.info.main,
    backgroundColor: alpha(tint, locked ? 0.12 : 0.15),
    border: `1px solid ${alpha(tint, locked ? 0.3 : 0.4)}`,
    '& .MuiChip-icon': {
      color: locked ? theme.palette.text.secondary : theme.palette.info.main,
    },
    '& .MuiChip-deleteIcon': {
      color: alpha(theme.palette.info.main, 0.6),
      transition: theme.transitions.create('color'),
      '&:hover': { color: theme.palette.info.main },
    },
  };
});
